module.exports = __webpack_public_path__ + "KaTeX_Size1-Regular.f50c0b58.ttf";